import React from 'react'
import Products from './Products'

const Home = () => {
  return (
    <div>
        <Products />
    </div>
  )
}

export default Home